import About from "./components/About";
import Contact from "./components/Contact";
import Experience from "./components/Experience";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import Portfolio from "./components/Skills";
import SocialLinks from "./components/SocialLinks";
import Education from'./components/Education'
import Qoutation from "./components/Qoutation";
import { motion, useScroll,useSpring } from "framer-motion"

function App() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  return (
    <div>
       <motion.div className="progress-bar" style={{ scaleX }} />
      <NavBar />
      <Home />
      <Qoutation />
      <About />
      <Education/>
      <Portfolio />
      <Experience />
      <Contact />

      <SocialLinks />
    </div>
  );
}

export default App;
